<template>
  <section>
    <div class="personal-center-form__section">
      <h1 class="loan_detail_h1"><span>申请时间　{{loanAllData.applyDate}}</span></h1>
      <div class="loan_detail_first">
        <ul class="text-center">
          <li>
            <em>借款金额</em>
            <strong>¥{{loanAllData.loanAmount}}</strong>
          </li>
          <li>
            <em>审核状态</em>
            <strong>{{loanAllData.auditState}} <img
              src="../../../static/images/loan_state.png"></strong>
          </li>
          <li>
            <el-button type="primary" class="btn" @click="showManagerDialog = true">客户经理</el-button>
            <el-button type="primary" class="btn" @click="showAgreement">电子合同</el-button>
          </li>
        </ul>
      </div>

      <div class="loan_detail_second">
        <ul>

          <li><span>借款主体</span><strong :title="loanAllData.custName">{{loanAllData.custName}}</strong></li>
          <li><span>年化利率</span><strong>{{loanAllData.yearRate | addThousandSign(2)}}%</strong></li>
          <li><span>起息日</span><strong>{{loanAllData.loanSdate}}</strong></li>
          <li><span>借款期限</span><strong>{{loanAllData.loanExpires}}</strong></li>
          <li><span>银行账户</span><strong>{{loanAllData.bankAccountInfo}}</strong></li>

          <li v-if="Number(userInfo.crmCustomerType) === 1"><span>证件号</span><strong>{{loanAllData.custLicense}}</strong></li>
          <li v-if="Number(userInfo.crmCustomerType) === 2"><span>营业执照号</span><strong :title="loanAllData.enterpriseNumber">{{loanAllData.enterpriseNumber}}</strong></li>
          <li><span>年咨询费率</span><strong>{{loanAllData.yearRateConsulting | addThousandSign(2)}}%</strong></li>
          <li><span>结息日</span><strong>{{loanAllData.loanEdate}}</strong></li>
          <li><span>还款方式</span><strong>{{loanAllData.repayType}}</strong></li>
          <li><span>咨询费计算方式</span><strong>{{loanAllData.repayTypeZxf}}</strong></li>
        </ul>
      </div>

      <div class="loan_detail_three">
        <div class="table-title">
          还款计划

            <!-- <router-link :to="toWholeRepay" class="btn" tag="button" :disabled="banRepay()">按期还款</router-link> -->
          <div class="btn_cont" v-if="Number(userInfo.crmCustomerType) === 1">
            <!-- <router-link :to="toWholeRepay" class="btn" tag="button" :disabled="banRepay()">按期还款</router-link> -->
            <router-link :to="toPrepayment" class="btn" tag="button" :disabled="banRepay()">提前还款</router-link>
          </div>
          <div class="tips_info el-icon-information">企业用户只支持线下还款！</div>
        </div>
        <el-table class="table-body pointer" :data="loanAllData.repayInfoList" style="width: 100%"
                  @row-click="roRepaymentInfo">
          <el-table-column prop="period" label="期次" width="70">
            <template slot-scope="scope">
              <span class="item_index">{{scope.row.period}}</span>
            </template>
          </el-table-column>
          <el-table-column label="本金" width="110">
            <template slot-scope="scope">¥{{scope.row.repayPrincipal | addThousandSign(2)}}</template>
          </el-table-column>
          <el-table-column label="利息" width="110">
            <template slot-scope="scope">¥{{scope.row.repayInterest | addThousandSign(2)}}</template>
          </el-table-column>
           <el-table-column label="咨询费" width="110">
            <template slot-scope="scope">¥{{scope.row.repayConsulting | addThousandSign(2)}}</template>
          </el-table-column>
          <el-table-column prop="repayDate" label="计划还款日期" width="120"></el-table-column>
          <el-table-column label="计划还款金额" width="137">
            <template slot-scope="scope">¥{{scope.row.repaySum | addThousandSign(2)}}</template>
          </el-table-column>
          <el-table-column label="未还金额" width="128">
            <template slot-scope="scope"><span style="color:#EB662B;">¥{{scope.row.balancedSum | addThousandSign(2)}}</span>
            </template>
          </el-table-column>
          <el-table-column label="状态" prop="repayStatus"></el-table-column>
        </el-table>
        <el-pagination v-if="loanAllData.repayInfoList.length > 0" class="pament-list-pagination" :small="isSmall"
                       layout="prev, pager, next" :page-count="loanAllData.pageCount" :page-size="pageSize"
                       :current-page="pageCurrent"
                       style="text-align: center;" @current-change="changePage"></el-pagination>
      </div>
    </div>

    <el-dialog class="showManagerDialog" title="客户经理信息" :visible.sync="showManagerDialog">
      <dl>
        <dt><img :src="magerweima"></dt>
        <dd>
          <div class="name_title">姓名</div>
          <div class="name_text">{{loanAllData.managerFullName}}</div>
          <div class="name_title">手机</div>
          <div class="name_text">{{loanAllData.managerMobile}}</div>
          <div class="name_title">邮箱</div>
          <div class="name_text">{{loanAllData.managerEmail}}</div>
        </dd>
      </dl>
    </el-dialog>

    <el-dialog class="contract dialog" top="5%" title="电子合同" :visible.sync="showAgreementDialog">
      <div class="contract__dialog-body agreement_contract"><img :src="readContract"></div>
      <div slot="footer" class="dialog__footer">

        <el-button v-if="signBtn.isShow" class="dialog__footer__confirm-btn sign_btn" :disabled="signBtn.state" @click="signAgreement"
                   style="margin-right:30px;">
          {{signBtn.text}}
        </el-button>
        <a :href="downAgreement" class="down_agreen">下载</a>
      </div>
    </el-dialog>

  </section>
</template>
<script>
  import { mapGetters, mapActions, mapMutations } from 'vuex';
  import * as types from '../../vuex/types';

  export default {
    data () {
      return {
        frontApplyId: this.$route.params.frontApplyId,
        pageCurrent: 1,
        pageSize: 10,
        isSmall: true,
        index: 1,
        showManagerDialog: false,
        showAgreementDialog: false,
        signBtn: {
          state: false,
          text: '签署公章',
          isShow: true
        }
      };
    },
    computed: {
      ...mapGetters({
        loanAllData: types.GET_LOAN_INFO_DETAIL,
        userInfo: types.GET_USER,
        successModal: types.GET_SUCCESS_MESSAGE,
        failModal: types.GET_FAIL_MESSAGE,
        imgSrcPrefix: types.GET_IMAGE_SRC_PREFIX,
        redContract: types.GET_CONTRACT_IMAGE_SRC,
        frontItemApplyState: types.FRONT_ITEM_STATE_FRONT
      }),
      magerweima () {
        return `${this.imgSrcPrefix}${this.loanAllData.managerPicture}`;
      },
      readContract () {
        return `${this.redContract}01&loanItemApplyId=${this.loanAllData.itemApplyId}&itemContractSigned=${this.loanAllData.itemContractSigned}`;
      },
      downAgreement () {
        return `/mingdao/mobile/item/pdfSignatureController/readContract.ht?download=true&fileType=PDF&identify=01&isOverseasCustome=N&loanItemApplyId=${this.loanAllData.itemApplyId}&itemContractSigned=${this.loanAllData.itemContractSigned}&id=${Math.random()}`;
      },
      toPrepayment () {
        return `/prepayment/${this.loanAllData.itemApplyId}?frontApplyId=${this.$route.params.frontApplyId}`;
      },
      toWholeRepay () {
        return `/wholeRepay/${this.loanAllData.itemApplyId}?frontApplyId=${this.$route.params.frontApplyId}`;
      }
    },
    methods: {
      changeSignBtn () {
        if (this.loanAllData.itemContractSigned === '-1') {
          this.signBtn.isShow = false;
          this.signBtn.state = false;
          this.signBtn.text = '签署公章';
        } else if (this.loanAllData.itemContractSigned === '3') {
          this.signBtn.isShow = true;
          this.signBtn.state = true;
          this.signBtn.text = '已签章';
        } else {
          this.signBtn.isShow = true;
          this.signBtn.state = false;
          this.signBtn.text = '签署公章';
        }
      },
      ...mapActions({
        getLoanAllData: types.GET_LOAN_ALL_DATA,
        signAture: types.SIGN_AGREEMENT,
        downContract: types.DOWN_AGREEMENT
      }),
      ...mapMutations({
        setLoanAllData: types.SET_LOAN_ALL_DATA,
        setSuccessModal: types.SET_SUCCESS_MESSAGE_STATE,
        setFailModal: types.SET_FAIL_MESSAGE_STATE,
        setSigned: types.SET_SIGNED
      }),
      showAgreement () {
        if (this.loanAllData.itemContractSigned === '-1' || this.loanAllData.itemContractSigned === '2' || this.loanAllData.itemContractSigned === '3') {
          this.showAgreementDialog = true;
        } else {
          this.setFailModal({
            show: true,
            content: '合同尚未生成，请等待客户经理审批生成合同'
          });
        }
      },
      changePage (currentPage) {
        this.pageCurrent = currentPage;
        this.getData();
      },
      getData () {
        this.getLoanAllData({
          token: this.userInfo.token,
          frontApplyId: this.frontApplyId,
          pageCurrent: this.pageCurrent,
          pageSize: this.pageSize,
          frontItemApplyState: this.frontItemApplyState
        }).then((res) => {
          const data = res.data;
          if (Number(data.code) === 0) {
            this.setLoanAllData(data.data);
            setTimeout(() => {
              this.changeSignBtn();
            }, 300);
          } else {
            this.setFailModal({
              show: true,
              content: data.result
            });
          }
        });
      },
      signAgreement () {
        const _this = this;
        if (this.loanAllData.itemContractSigned === '2') {
          this.signBtn.state = true;
          this.signBtn.text = '签章中…';
          this.signAture({
            itemApplyId: this.loanAllData.itemApplyId
          }).then((res) => {
            const data = res.data;
            if (data.code === 0) {
              _this.buttonState = false;
              _this.setSigned(data);
              _this.setSuccessModal({
                show: true,
                content: data.result
              });
              _this.changeSignBtn();
            } else if (data.code === 1) {
              this.setFailModal({
                show: true,
                content: data.result
              });
              _this.changeSignBtn();
            }
          });
        } else {
          this.setFailModal({
            show: true,
            content: '合同已签章！'
          });
        }
      },
      roRepaymentInfo (row) {
        this.$router.push({path: `/repaymentInfo/${row.period}/${row.financePayId}/${row.repayStatusCode}`});
      },
      // banRepay () {
      //   switch (this.loanAllData.frontApplyState) {
      //     case '32':
      //       return false
      //     default:
      //       return true
      //   }
      // }
      banRepay () {
        switch (this.loanAllData.advRePayState) {
          case '1':
            return false;
          default:
            return true;
        }
      }
    },
    mounted () {
      this.getData();
    }
  };
</script>
<style lang="scss">
  .showManagerDialog {
    dl {
      overflow: hidden;

      dt {
        width: 159px;
        height: 159px;
        overflow: hidden;
        float: left;
        background: $darkerGray;

        img {
          width: 100%;
          height: 100%
        }
      }

      dd {
        width: 232px;
        height: 159px;
        float: right;

        .name_title {
          color: $lightWaterBlue;
          font-size: 12px;
          line-height: 24px;
        }

        .name_text {
          color: $personalCenterTitleBlack;
          font-size: 20px;
          margin-bottom: 10px;
          font-weight: bold;
        }
      }
    }

    .el-dialog__body {
      padding: 0;
    }
    .el-dialog {
      width: 485px;
      height: 274px;
      padding: 0 26px;
      box-sizing: border-box;

      .el-dialog__header {
        padding: 20px 0;

        .el-dialog__headerbtn {
          width: 12px;
          height: 12px;
          color: #A9A9A9;
          margin: -22px -22px 0 0;
        }
      }
      .el-dialog__title {
        font-size: 20px;

        &:after {
          display: block;
          content: "Account Manager";
          font-size: 12px;
          line-height: 22px;
          text-indent: 8px;
          font-weight: normal;
          font-family: "Microsoft YaHei";
        }
      }
    }
  }

  .loan_detail_h1 {
    height: 35px;
    line-height: 35px;
    margin-bottom: 0;
    overflow: hidden;

    span {
      float: right;
      font-family: "FZLanTingHei-DB-GBK", "Microsoft YaHei";
      font-size: 10px;
      font-weight: normal;
      color: $lightSilver;
    }
  }

  .loan_detail_first {
    overflow: hidden;

    ul {
      width: 100%;
      height: 156px;
      margin-bottom: 20px;
      box-sizing: border-box;
      overflow: hidden;
      padding: 30px 15px 0 15px;
      border-radius: 7px;
      background: $white;

      li {
        width: 278px;
        height: 95px;
        float: left;
        border-left: 1px solid #eee;
        font-size: 25px;
        color: #59402E;
        font-weight: bold;

        &:first-child {
          border: none;

          em:after {
            content: 'Loan amount';
          }
        }

        &:nth-child(2) {
          em:after {
            content: 'Audit state';
          }
        }

        em {
          display: block;
          font-size: 17px;
          color: $personalCenterFormLabel;
          line-height: 38px;
          font-style: normal;
          font-family: "FZLanTingHei_GBK";

          &:after {
            display: block;
            color: #3E454D;
            font-size: 12px;
            line-height: 12px;
            font-family: "MyriadPro-Regular";
          }
        }

        strong {
          display: block;
          line-height: 47px;
          font-family: "MyriadPro-Regular", "Microsoft YaHei";
          font-size: 22px;
          color: #374B5E;

          img {
            vertical-align: -3px;
          }
        }

        .btn {
          display: block;
          width: 109px;
          height: 36px;
          margin: 8px auto;
          background: #374B5E;
          border-color: #D6DADE;
        }
      }
    }
  }

  .loan_detail_second {
    margin-bottom: 20px;
    overflow: hidden;

    ul {
      width: 100%;
      height: 187px;
      box-sizing: border-box;
      border-radius: 7px;
      padding: 26px 20px;
      background: $white;

      li {
        padding-left: 20px;
        box-sizing: border-box;
        height: 64px;
        overflow: hidden;
        float: left;
        border-right: 1px solid #eee;

        span {
          display: block;
          height: 26px;
          color: $lightSilver;
          font-size: 12px;
          line-height: 28px;
        }
        strong {
          width: 94%;
          display: block;
          height: 26px;
          color: #34495e;
          font-size: 14px;
          line-height: 28px;
          overflow: hidden;white-space: nowrap;text-overflow: ellipsis;
        }
      }

      li:first-child {

        width: 202px;
        padding-left: 0;
        border-bottom: 1px solid #eee;
      }
      li:nth-child(2) {

        width: 154px;
        border-bottom: 1px solid #eee;
      }
      li:nth-child(3) {

        width: 140px;
        border-bottom: 1px solid #eee;
      }
      li:nth-child(4) {

        width: 150px;
        border-bottom: 1px solid #eee;
      }
      li:nth-child(5) {
        width: 184px;
        border: none;
        border-bottom: 1px solid #eee;
      }
      li:nth-child(6) {

        width: 202px;
        padding-top: 14px;
        padding-left: 0;
      }
      li:nth-child(7) {

        width: 154px;
        padding-top: 14px;
        border-bottom: none;
      }
      li:nth-child(8) {

        width: 140px;
        padding-top: 14px;
        border-bottom: none;
      }
      li:nth-child(9) {

        width: 150px;
        padding-top: 14px;
        border-bottom: none;
      }
      li:nth-child(10) {
        width: 184px;
        padding-top: 14px;
        border: none;
      }
    }
  }

  .loan_detail_three {
    overflow: hidden;
    border-radius: 3px;
    background: $white;

    .table-title {
      height: 45px;
      overflow: hidden;
      line-height: 50px;
      font-size: 16px;
      color: #34495e;
      text-indent: 18px;

      .btn_cont {
        display: inline-block;
        float: right;
        margin-right: 10px;

        .btn {
          display: inline-block;
          margin-right: 13px;
          width: 87px;
          height: 28px;
          line-height: 26px;
          text-indent: 0;
          text-align: center;
          border-radius: 3px;
          font-size: 14px;
          border: 1px solid $orange;
          color: $orange;
          cursor: pointer;
          background-color: transparent;
          &[disabled] {
            cursor: not-allowed;
            box-shadow: none;
            background-color: transparent;
            opacity: .65;
          }

        }
      }
    }

    .pament-list-pagination {
      margin: 15px auto;
    }

    .tips_info {
      position: relative;
      height: 50px;
      color: #00C0FF;
      font-size: 14px;
      top: -2px;

      &:before {
        margin-right: 5px;
      }
    }
  }

  .agreement_contract {
    height: auto;
    min-height: 270px;

    img {
      width: 100%;
      height: auto;
    }
  }

  .sign_btn:hover {
    color: $white;
  }
  .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
    background-color: #eee;
  }
  .down_agreen ,.sign_btn:hover{
    display: inline-block;
    border: 0;
    min-width: 120px;
    height: 45px;
    border-radius: 3px;
    font-size: 16px;
    color: #fff;
    line-height: 45px;
    text-align: center;
    background: #ff8b38
  }

</style>




// WEBPACK FOOTER //
// LoanDetail.vue?fedd4f3c